import React from "react";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { PRIORITIES } from "../../lib/utils";

const PRIORITY_INDICATORS = {
    low: { dot: "bg-blue-400", label: "Basse" },
    medium: { dot: "bg-yellow-400", label: "Moyenne" },
    high: { dot: "bg-orange-500", label: "Haute" },
    critical: { dot: "bg-red-500", label: "Critique" },
};

function PriorityOption({ priority }) {
    const ind = PRIORITY_INDICATORS[priority.id];
    return (
        <span className="flex items-center gap-2.5">
            <span className={`w-2.5 h-2.5 rounded-full ${ind?.dot || "bg-gray-400"}`} />
            <span>{priority.label}</span>
            {priority.id === "critical" && (
                <span className="text-[10px] font-semibold text-red-500 bg-red-50 px-1.5 py-0.5 rounded">URGENT</span>
            )}
        </span>
    );
}

export function PrioritySelect({ value, onChange, allowedPriorities }) {
    const options = allowedPriorities ? PRIORITIES.filter((p) => allowedPriorities.includes(p.id)) : PRIORITIES;
    const current = PRIORITIES.find((p) => p.id === value);
    return (
        <div className="form-group">
            <Label htmlFor="priority" className="form-label">Priorité</Label>
            <Select value={value} onValueChange={onChange}>
                <SelectTrigger data-testid="ticket-priority">
                    <SelectValue>{current ? <PriorityOption priority={current} /> : null}</SelectValue>
                </SelectTrigger>
                <SelectContent>
                    {options.map((p) => (
                        <SelectItem key={p.id} value={p.id}><PriorityOption priority={p} /></SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
